import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { getApiBaseUrl, ADD_ACTIVITY, LOGIN } from "../../../Config/Config";
import { Select } from "antd";
// const { Option } = Select;

const FilterTreeAddFilterModel = ({
  onClose,
  blockName,
  blockId,
  areaName,
  ahuid,
  ahuName,
  onSuccess,
}) => {
  console.log(areaName, ahuid, ahuName, "ahuid");
  const [filterId, setFilterId] = useState("");
  const [filterSize, setFilterSize] = useState("");
  const [filterDimensions, setFilterDimensions] = useState("");
  const [lastCleaningDate, setLastCleaningDate] = useState("");
  const [filterTypes, setFilterTypes] = useState([]);
  console.log(filterTypes, "filterTypes");
  const [selectedFilterType, setSelectedFilterType] = useState(undefined);
  console.log(selectedFilterType, "selectedFilterType");

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [loading, setLoading] = useState(false);
  console.log(loading, "loading");
  const [authLoading, setAuthLoading] = useState(false);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  console.log(error, "error");

  useEffect(() => {
    fetchFilterTypes();
  }, []);


  const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const toSQLDate = (dateStr) => {
  if (!dateStr || dateStr.trim() === "") {
    console.log("LastCleaningDate: user left empty → using today's date");
    return getTodayDate(); // or return null if backend allows NULL
  }

  const d = new Date(dateStr);
  if (isNaN(d.getTime())) {
    console.warn("Invalid date selected:", dateStr, "→ falling back to today");
    return getTodayDate();
  }

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const formatted = `${year}-${month}-${day}`;

  // console.log("Formatted LastCleaningDate:", formatted);
  return formatted;
};

  const fetchFilterTypes = async () => {
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/getFilterType`);
      if (!res.ok) throw new Error("Failed to fetch filter types");
      const data = await res.json();
      if (data?.Status) {
        setFilterTypes(data.ResultData);
      } else {
        console.error("Error in API response:", data);
        setFilterTypes([]);
      }
    } catch (err) {
      console.error("Network error:", err);
      setFilterTypes([]);
    }
  };

  const handleSave = async () => {
    const logActivity = async (isSuccess, notes) => {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user?.UserID,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: notes,
            Location: "Add Filter",
            IsSucces: isSuccess ? 1 : 0,
          }),
        });
      } catch (err) {
        console.error("Activity log failed:", err);
      }
    };

    const payload = {
      AHUId: ahuid, // ✅ selected AHU ID
      AssetType: selectedFilterType,
      Location: blockId, // ✅ Block ID
      Dimensions: filterDimensions,
      MicronRating: filterSize,
      CurrentStatus: "Active",
      Lable: filterId,
      CreatedBy: user?.UserID,
    LastCleaningDate: toSQLDate(lastCleaningDate) || "NULL",
      Loctypeid: 0,
    };
 try {
  setLoading(true);

  const res = await fetch(`${getApiBaseUrl()}/filterph2/addfilter`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const result = await res.json();

  console.log("Add filter full response:", result); 


  const innerResult = result?.ResultData?.[0];

  if (res.ok && innerResult?.Status === "Success") {
    await logActivity(
      true,
      `Filter "${filterId}" added to AHU "${ahuName}" (Block: ${blockName}, Area: ${areaName})`
    );

    Swal.fire("Success", "Filter added successfully!", "success").then(() => {
      onSuccess();   
      onClose();     
    });
  } else {

    const errorMsg =
      innerResult?.ResultMessage ||
      result?.message ||
      result?.Message ||
      "Unknown error from server";

    console.error("Add filter failed:", errorMsg, result);

    await logActivity(
      false,
      `Failed to add filter "${filterId}": ${errorMsg}`
    );

    Swal.fire("Error", errorMsg, "error");
  }
} catch (err) {
  console.error("Network/server error:", err);

  await logActivity(false, `Network error adding filter "${filterId}"`);
  Swal.fire("Error", "Failed to connect to server", "error");
} finally {
  setLoading(false);
  setAskPassword(false);
  setPassword("");
}
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !ahuid ||
      !selectedFilterType ||
      !filterId ||
      !filterDimensions ||
      !filterSize
    ) {
      Swal.fire(
        "Validation Error",
        "Please fill all required fields",
        "warning",
      );
      return;
    }

    setAskPassword(true);
  };

  const handleAuth = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setAuthLoading(true);
    setError("");

    try {
      if (!user?.UserName) {
        throw new Error("User name not found in session data.");
      }

      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await handleSave();
      } else {
        throw new Error(
          data.Message || "Invalid credentials. Please try again.",
        );
      }
    } catch (err) {
      setError(err.message || "Unable to authenticate. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };
  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", zIndex: 1055 }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Filter</h5>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "22px",
                  fontWeight: "bold",
                  lineHeight: "1",
                  cursor: "pointer",
                }}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Block</label>
                  <input className="form-control" value={blockName} disabled />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Area</label>
                  <input
                    className="form-control"
                    value={areaName || "—"}
                    disabled
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">AHU</label>
                  <input className="form-control" value={ahuName} disabled />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Filter ID    <span className="text-danger ms-1">*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={filterId}
                    onChange={(e) => setFilterId(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Filter Size (Micron) <span className="text-danger"> *</span></label>
                  <input
                    type="number"
                    className="form-control"
                    value={filterSize}
                    onChange={(e) => setFilterSize(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Filter Type / Category <span className="text-danger"> *</span></label>
                 
                  <Select
                    showSearch
                    placeholder="Select Filter Type"
                    value={selectedFilterType ?? undefined}
                    onChange={(value) => setSelectedFilterType(value)}
                    className="w-100"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option?.children
                        ?.toString()
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    disabled={askPassword}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement
                    }
                  >
                    {filterTypes.map((item) => (
                      <Select.Option key={item.Id} value={item.Id}>
                        {item.AssetType}
                      </Select.Option>
                    ))}
                  </Select>
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Filter Dimensions<span className="text-danger"> *</span></label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="L x W x H"
                    value={filterDimensions}
                    onChange={(e) => setFilterDimensions(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-3 d-none">
                  <label className="form-label">Last Cleaning Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={lastCleaningDate}
                    onChange={(e) => setLastCleaningDate(e.target.value)}
                  />
                </div>
              </div>
              {askPassword && (
                <div className="mt-2">
                  <div className="mb-3 w-lg-75 col-4 ">
                    <label className="form-label">
                      Confirm Password <span className="text-danger"> *</span>
                    </label>
                    <div className="pass-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="pass-input form-control"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setError("");
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onCut={(e) => e.preventDefault()}
                        placeholder="Enter Password"
                      />
                      <span
                        className={`ti toggle-password ${
                          showPassword ? "ti-eye" : "ti-eye-off"
                        }`}
                        onClick={() => setShowPassword(!showPassword)}
                      ></span>
                    </div>
                  </div>
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={handleAuth}
                    disabled={authLoading || !password}
                  >
                    {authLoading ? "Verifying..." : "Confirm"}
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setAskPassword(false);
                      setPassword("");
                      setError("");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
            {!askPassword && (
              <div className="modal-footer gap-2">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Save
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1050 }}
        onClick={onClose}
      />
    </>
  );
};

FilterTreeAddFilterModel.propTypes = {
  onClose: PropTypes.func.isRequired,

  blockName: PropTypes.string,
  blockId: PropTypes.number,

  areaName: PropTypes.string,
  areaId: PropTypes.number,

  ahuid: PropTypes.number,
  ahuName: PropTypes.string,
  onSuccess: PropTypes.string,
};

export default FilterTreeAddFilterModel;
